(() => {
  const journeys = document.querySelectorAll('[data-l2c-vital-journey]');
  if (!journeys.length) return;

  journeys.forEach((journey) => {
    if (journey.dataset.l2cReady === 'true') return;
    journey.dataset.l2cReady = 'true';

    const stage = journey.querySelector('.l2c-vital-scroll-stage');
    const canvas = journey.querySelector('.l2c-vital-canvas');
    const frameData = journey.querySelector('[data-l2c-vital-frames]');
    const mobileFrameData = journey.querySelector('[data-l2c-vital-mobile-frames]');
    const panels = Array.from(journey.querySelectorAll('.l2c-vital-copy'));
    const tiltTargets = Array.from(journey.querySelectorAll('[data-l2c-watch-tilt]'));
    const ctx = canvas.getContext('2d');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let desktopFrameUrls = [];
    let mobileFrameUrls = [];
    let frameUrls = [];
    let frames = [];
    let currentFrame = -1;
    let activeFrameMode = '';
    let targetProgress = 0;
    let renderProgress = 0;
    let ticking = false;
    let dpr = 1;
    const getFrameSpeed = () => window.innerWidth <= 720 ? 1.12 : 1;
    let loadedFrames = [];

    try {
      desktopFrameUrls = JSON.parse(frameData.textContent || '[]');
    } catch (error) {
      desktopFrameUrls = [];
    }

    try {
      mobileFrameUrls = JSON.parse(mobileFrameData?.textContent || '[]');
    } catch (error) {
      mobileFrameUrls = [];
    }

    const getFrameMode = () => window.innerWidth <= 720 && mobileFrameUrls.length ? 'mobile' : 'desktop';

    const setFrameSource = () => {
      activeFrameMode = getFrameMode();
      frameUrls = activeFrameMode === 'mobile' ? mobileFrameUrls : desktopFrameUrls;
    };

    setFrameSource();

    const resize = () => {
      const nextFrameMode = getFrameMode();
      if (nextFrameMode !== activeFrameMode) {
        activeFrameMode = nextFrameMode;
        frameUrls = activeFrameMode === 'mobile' ? mobileFrameUrls : desktopFrameUrls;
        frames = [];
        loadedFrames = [];
        currentFrame = -1;
        loadFrames();
      }
      const rect = canvas.getBoundingClientRect();
      dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
      drawFrame(currentFrame < 0 ? 0 : currentFrame);
    };

    const drawFrame = (index) => {
      const image = frames[index];
      if (!image || !loadedFrames[index]) return false;
      const cw = canvas.width;
      const ch = canvas.height;
      const iw = image.naturalWidth || image.width;
      const ih = image.naturalHeight || image.height;
      const mobilePadded = window.innerWidth <= 720;
      const tabletPadded = window.innerWidth > 720 && window.innerWidth <= 900;
      const dedicatedMobileFrames = activeFrameMode === 'mobile';
      const coverScale = Math.max(cw / iw, ch / ih);
      const mobilePortrait = dedicatedMobileFrames && ch / cw >= 1.25;
      const scale = dedicatedMobileFrames
        ? Math.min(cw / iw, ch / ih) * (mobilePortrait ? 0.96 : 0.65)
        : mobilePadded ? coverScale * 0.72 : tabletPadded ? coverScale * 0.86 : coverScale;
      const dw = iw * scale;
      const dh = ih * scale;
      const dx = (cw - dw) / 2;
      const dy = dedicatedMobileFrames ? ch * (mobilePortrait ? 0.12 : 0.07) : mobilePadded ? (ch - dh) * 0.42 : (ch - dh) / 2;
      ctx.fillStyle = window.innerWidth <= 900 ? '#f8f4ef' : '#f7f4ef';
      ctx.fillRect(0, 0, cw, ch);
      if (window.innerWidth <= 900) {
        const gradient = ctx.createLinearGradient(0, 0, cw, ch);
        gradient.addColorStop(0, 'rgba(255, 250, 248, 0.96)');
        gradient.addColorStop(0.48, 'rgba(248, 244, 239, 0.9)');
        gradient.addColorStop(1, 'rgba(239, 247, 242, 0.96)');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, cw, ch);
      }
      ctx.drawImage(image, dx, dy, dw, dh);
      return true;
    };

    const progressForStage = () => {
      const rect = stage.getBoundingClientRect();
      const scrollable = Math.max(1, rect.height - window.innerHeight);
      return Math.max(0, Math.min(1, -rect.top / scrollable));
    };

    const updatePanels = (progress) => {
      panels.forEach((panel) => {
        const start = Number(panel.dataset.start || 0);
        const end = Number(panel.dataset.end || 1);
        const fade = 0.055;
        let opacity = 0;
        if (progress >= start && progress <= end) {
          const inAmount = Math.min(1, (progress - start) / fade);
          const outAmount = Math.min(1, (end - progress) / fade);
          opacity = Math.max(0, Math.min(inAmount, outAmount));
        }
        const y = 28 * (1 - opacity);
        panel.style.opacity = opacity.toFixed(3);
        if (panel.classList.contains('l2c-vital-copy-final') && window.innerWidth > 900 && !journey.classList.contains('l2c-vital-journey--living-signal')) {
          panel.style.transform = `translate(-50%, calc(-50% + ${y}px))`;
        } else {
          panel.style.transform = `translateY(${y}px)`;
        }
      });
    };

    const render = () => {
      ticking = false;
      renderProgress += (targetProgress - renderProgress) * 0.72;
      if (Math.abs(targetProgress - renderProgress) < 0.001) renderProgress = targetProgress;
      const maxIndex = frames.length - 1;
      const videoProgress = Math.min(1, renderProgress * getFrameSpeed());
      const desiredFrameIndex = Math.min(maxIndex, Math.max(0, Math.round(videoProgress * maxIndex)));
      let frameIndex = desiredFrameIndex;
      while (frameIndex > 0 && !loadedFrames[frameIndex]) frameIndex -= 1;
      if (frameIndex !== currentFrame) {
        if (drawFrame(frameIndex)) currentFrame = frameIndex;
      }
      updatePanels(renderProgress);
      if (renderProgress !== targetProgress) requestTick();
    };

    const requestTick = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(render);
    };

    const onScroll = () => {
      targetProgress = progressForStage();
      requestTick();
    };

    const loadFrames = () => {
      if (!frameUrls.length) return;
      frames = frameUrls.map((url, index) => {
        const image = new Image();
        image.decoding = 'async';
        image.loading = 'eager';
        image.src = url;
        image.addEventListener('load', () => {
          loadedFrames[index] = true;
          if (index === 0 && currentFrame < 0) {
            currentFrame = 0;
            drawFrame(0);
          }
          requestTick();
        }, { once: true });
        return image;
      });
    };

    const initWatchTilt = () => {
      if (reducedMotion || !tiltTargets.length) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      tiltTargets.forEach((target) => {
        target.addEventListener('pointermove', (event) => {
          const rect = target.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;
          const rotateY = x * 18;
          const rotateX = y * -14;
          target.style.transform = `perspective(920px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) translate3d(0, -6px, 0)`;
        }, { passive: true });

        target.addEventListener('pointerleave', () => {
          target.style.transform = 'perspective(920px) rotateX(0deg) rotateY(0deg) translate3d(0, 0, 0)';
        }, { passive: true });
      });
    };

    loadFrames();
    initWatchTilt();
    resize();
    updatePanels(0);
    window.addEventListener('resize', resize, { passive: true });

    if (reducedMotion) {
      currentFrame = Math.min(frames.length - 1, Math.floor(frames.length * 0.62));
      const image = frames[currentFrame];
      if (image) {
        if (image.complete) drawFrame(currentFrame);
        else image.addEventListener('load', () => drawFrame(currentFrame), { once: true });
      }
      updatePanels(1);
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initializedVisuals = new WeakSet();

  const initVisual = async (container) => {
    if (initializedVisuals.has(container) || container.dataset.l2cThreeReady === 'true') return;
    initializedVisuals.add(container);
    container.dataset.l2cThreeReady = 'true';

    let THREE;
    try {
      const moduleSource = window.L2C_THREE_MODULE_URL || 'https://unpkg.com/three@0.160.0/build/three.module.js';
      const moduleUrl = moduleSource.startsWith('//') ? `${window.location.protocol}${moduleSource}` : moduleSource;
      THREE = await import(moduleUrl);
    } catch (error) {
      container.dataset.l2cThreeReady = 'failed';
      initializedVisuals.delete(container);
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.className = 'l2c-three-score-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    container.prepend(canvas);

    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      antialias: true,
      powerPreference: 'high-performance'
    });
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 8.4);

    const group = new THREE.Group();
    const orbitalGroup = new THREE.Group();
    const fieldGroup = new THREE.Group();
    scene.add(group);
    group.add(orbitalGroup, fieldGroup);

    const mint = new THREE.Color('#52d88f');
    const blush = new THREE.Color('#d75f55');
    const gold = new THREE.Color('#d5b55c');
    const aqua = new THREE.Color('#79dce2');
    const white = new THREE.Color('#f7fff9');

    const makeRing = ({ radius, tube, color, opacity, rotation }) => {
      const ring = new THREE.Mesh(
        new THREE.TorusGeometry(radius, tube, 18, 220),
        new THREE.MeshBasicMaterial({
          color,
          transparent: true,
          opacity,
          blending: THREE.AdditiveBlending,
          depthWrite: false
        })
      );
      ring.rotation.set(rotation[0], rotation[1], rotation[2]);
      orbitalGroup.add(ring);
      return ring;
    };

    const rings = [
      makeRing({ radius: 2.95, tube: 0.012, color: mint, opacity: 0.46, rotation: [Math.PI / 2.8, 0.12, 0] }),
      makeRing({ radius: 2.18, tube: 0.01, color: aqua, opacity: 0.3, rotation: [Math.PI / 2.15, -0.35, 0.34] }),
      makeRing({ radius: 1.48, tube: 0.008, color: gold, opacity: 0.26, rotation: [Math.PI / 2.55, 0.44, -0.25] }),
      makeRing({ radius: 3.42, tube: 0.006, color: blush, opacity: 0.22, rotation: [Math.PI / 2.35, -0.18, 0.62] })
    ];

    const signalPositions = [];
    const signalColors = [];
    const pointCount = 190;
    for (let i = 0; i < pointCount; i += 1) {
      const angle = i * 2.399963 + (i % 4) * 0.12;
      const radius = 1.18 + (i % 17) * 0.14;
      const yScale = 0.66 + (i % 5) * 0.025;
      const z = Math.sin(i * 1.37) * 0.58;
      signalPositions.push(Math.cos(angle) * radius * 1.22, Math.sin(angle) * radius * yScale, z);
      const color = i % 11 === 0 ? blush : i % 7 === 0 ? gold : i % 5 === 0 ? aqua : mint;
      signalColors.push(color.r, color.g, color.b);
    }

    const signalGeometry = new THREE.BufferGeometry();
    signalGeometry.setAttribute('position', new THREE.Float32BufferAttribute(signalPositions, 3));
    signalGeometry.setAttribute('color', new THREE.Float32BufferAttribute(signalColors, 3));

    const signalMaterial = new THREE.PointsMaterial({
      size: 0.105,
      vertexColors: true,
      transparent: true,
      opacity: 0.95,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });
    const signals = new THREE.Points(signalGeometry, signalMaterial);
    fieldGroup.add(signals);

    const haloGeometry = new THREE.BufferGeometry();
    haloGeometry.setAttribute('position', new THREE.Float32BufferAttribute(signalPositions, 3));
    const haloMaterial = new THREE.PointsMaterial({
      size: 0.24,
      color: mint,
      transparent: true,
      opacity: 0.12,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });
    const halos = new THREE.Points(haloGeometry, haloMaterial);
    fieldGroup.add(halos);

    const systemGroup = new THREE.Group();
    const systemLabels = [
      { color: '#52d88f', angle: 0.04, radius: 3.06 },
      { color: '#d75f55', angle: 1.22, radius: 2.82 },
      { color: '#d5b55c', angle: 2.48, radius: 3.0 },
      { color: '#79dce2', angle: 3.76, radius: 2.88 },
      { color: '#b9e6ca', angle: 5.02, radius: 2.96 }
    ];

    systemLabels.forEach((item) => {
      const system = new THREE.Mesh(
        new THREE.SphereGeometry(0.145, 32, 32),
        new THREE.MeshBasicMaterial({
          color: new THREE.Color(item.color),
          transparent: true,
          opacity: 0.9,
          blending: THREE.AdditiveBlending,
          depthWrite: false
        })
      );
      system.position.set(Math.cos(item.angle) * item.radius, Math.sin(item.angle) * item.radius * 0.7, 0.16);
      systemGroup.add(system);

      const glow = new THREE.Mesh(
        new THREE.SphereGeometry(0.34, 32, 32),
        new THREE.MeshBasicMaterial({
          color: new THREE.Color(item.color),
          transparent: true,
          opacity: 0.12,
          blending: THREE.AdditiveBlending,
          depthWrite: false
        })
      );
      glow.position.copy(system.position);
      systemGroup.add(glow);
    });
    orbitalGroup.add(systemGroup);

    const linePositions = [];
    systemLabels.forEach((item) => {
      const x = Math.cos(item.angle) * item.radius;
      const y = Math.sin(item.angle) * item.radius * 0.7;
      linePositions.push(0, 0, 0.02, x, y, 0.16);
    });
    const lineGeometry = new THREE.BufferGeometry();
    lineGeometry.setAttribute('position', new THREE.Float32BufferAttribute(linePositions, 3));
    const lines = new THREE.LineSegments(
      lineGeometry,
      new THREE.LineBasicMaterial({
        color: white,
        transparent: true,
        opacity: 0.2,
        blending: THREE.AdditiveBlending
      })
    );
    orbitalGroup.add(lines);

    const sweep = new THREE.Mesh(
      new THREE.TorusGeometry(2.95, 0.024, 14, 42, Math.PI * 0.62),
      new THREE.MeshBasicMaterial({
        color: mint,
        transparent: true,
        opacity: 0.75,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      })
    );
    sweep.rotation.set(Math.PI / 2.8, 0.12, 0);
    orbitalGroup.add(sweep);

    const counterSweep = new THREE.Mesh(
      new THREE.TorusGeometry(2.18, 0.018, 14, 48, Math.PI * 0.46),
      new THREE.MeshBasicMaterial({
        color: aqua,
        transparent: true,
        opacity: 0.56,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      })
    );
    counterSweep.rotation.set(Math.PI / 2.15, -0.35, 0.34);
    orbitalGroup.add(counterSweep);

    const resize = () => {
      const rect = container.getBoundingClientRect();
      const width = Math.max(1, Math.floor(rect.width));
      const height = Math.max(1, Math.floor(rect.height));
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      const aspect = width / height;
      camera.position.z = aspect > 1.45 ? 7.25 : aspect > 1.1 ? 7.8 : 8.4;
      group.scale.set(aspect > 1.45 ? 1.08 : 0.94, aspect > 1.45 ? 0.82 : 0.92, 1);
      camera.updateProjectionMatrix();
    };

    let frame = 0;
    let pointerX = 0;
    let pointerY = 0;

    container.addEventListener('pointermove', (event) => {
      const rect = container.getBoundingClientRect();
      pointerX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      pointerY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
    }, { passive: true });

    container.addEventListener('pointerleave', () => {
      pointerX = 0;
      pointerY = 0;
    }, { passive: true });

    const animate = () => {
      frame += reducedMotion ? 0 : 0.01;
      group.rotation.y += (Math.sin(frame * 0.34) * 0.18 + pointerX * 0.48 - group.rotation.y) * 0.07;
      group.rotation.x += (Math.sin(frame * 0.5) * 0.07 - pointerY * 0.24 - group.rotation.x) * 0.07;
      group.position.x += (pointerX * 0.18 - group.position.x) * 0.06;
      group.position.y += (-pointerY * 0.12 - group.position.y) * 0.06;
      fieldGroup.rotation.z = frame * 0.34 + pointerX * 0.1;
      fieldGroup.rotation.y = frame * 0.18 + pointerY * 0.08;
      orbitalGroup.rotation.z = frame * 0.22;
      rings.forEach((ring, index) => {
        ring.rotation.z += (index % 2 === 0 ? 0.006 : -0.0045);
        ring.material.opacity = [0.46, 0.3, 0.26, 0.22][index] + Math.sin(frame * 2 + index) * 0.045;
      });
      sweep.rotation.z = frame * 0.9;
      counterSweep.rotation.z = -frame * 1.16;
      signals.material.size = 0.095 + Math.sin(frame * 2.4) * 0.016 + Math.abs(pointerX) * 0.006;
      systemGroup.children.forEach((system, index) => {
        const pulse = 1 + Math.sin(frame * 2.4 + index * 0.8) * 0.18;
        system.scale.setScalar(pulse);
      });
      renderer.render(scene, camera);
      if (!reducedMotion) requestAnimationFrame(animate);
    };

    resize();
    window.addEventListener('resize', resize, { passive: true });
    animate();
  };

  const initAllVisuals = () => {
    document.querySelectorAll('[data-l2c-intel-map]').forEach((visual) => initVisual(visual));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVisuals, { once: true });
  } else {
    initAllVisuals();
  }

  window.addEventListener('load', initAllVisuals, { once: true });

  const observer = new MutationObserver(() => {
    if (document.querySelector('[data-l2c-intel-map]')) {
      initAllVisuals();
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
